<template>
  <div>
    <a-card>
      <detail-list title="订单信息" :col="2">
        <detail-list-item term="关联抢购订单号" v-if="detail.preSaleOrderNo&&detail.preSaleOrderNo.length>0">
          <a class="line-a" v-for="(item,index) in detail.preSaleOrderNo"
             v-show="item" :key="index" @click="onClickItem(item)">{{ item }}</a>
        </detail-list-item>
        <detail-list-item term="关联抢购商品">{{ detail.orderMainProName }}【商品ID:{{ detail.orderMainProId }}】
        </detail-list-item>
        <detail-list-item term="预约订单号">{{ detail.orderNo }}</detail-list-item>
        <detail-list-item term="游玩日期" v-if="detail.orderTravelDate">{{ detail.orderTravelDate }}</detail-list-item>
        <detail-list-item term="入离日期" v-else>{{ detail.orderCheckInDate }}至{{ detail.orderDepartureDate }}
        </detail-list-item>
        <detail-list-item term="预约量">{{ detail.orderTotalQty }}</detail-list-item>
        <detail-list-item term="差价">￥{{ detail.orderPaidFee }}</detail-list-item>
        <detail-list-item term="结算金额">{{ detail.orderTotalQty }}张券 <span
          v-if="detail.redeemCodeList!=null">（{{ detail.redeemCodeList.join(',') }}）</span>+￥{{ detail.orderPaidFee }}
        </detail-list-item>
        <detail-list-item term="客人备注">{{ detail.orderRemark ? detail.orderRemark : '----' }}</detail-list-item>
      </detail-list>
      <detail-list title="附加商品" :col="2" v-if="attachedSnapshotList&&attachedSnapshotList.length>0">
        <div v-for="(item,index) in attachedSnapshotList" :key="index">
          <detail-list-item term="商品数量">{{ item.attachedNum }}个</detail-list-item>
          <detail-list-item term="商品名称">{{ item.attachedName }}</detail-list-item>
          <detail-list-item term="商品单价">￥{{ item.attachedPrice }}</detail-list-item>
          <detail-list-item term="商品总价">￥{{ item.attachedTotalAmount }}</detail-list-item>
        </div>
      </detail-list>
      <detail-list title="出行人信息">
        <a-table
          rowKey="rowId"
          :columns="getTouristsColumns()"
          :dataSource="detail.orderPersonnel"
          :pagination="false"
          :bordered="true"
        ></a-table>
      </detail-list>
      <div style="margin-top: 20px"></div>
      <detail-list title="供应商备注" :col="1">
        <template v-if="detail.orderProviderRemarkList && detail.orderProviderRemarkList.length>0">
          <detail-list-item v-for="(item,index) in detail.orderProviderRemarkList" :key="index">
            {{ item }}
          </detail-list-item>
        </template>
        <detail-list-item v-else>{{ detail.orderProviderRemark }}</detail-list-item>
      </detail-list>
      <div style="margin-top: 20px"></div>
      <detail-list title="添加备注">
        <a-textarea
          style="max-width: 600px"
          v-model="remark"
          placeholder="请填输入备注"
          :maxLength="140"
          :rows="4"></a-textarea>
      </detail-list>
      <div style="margin-bottom: 40px;margin-top: 40px">
        <a-button style="margin-right: 10px" type="danger" v-if="detail.orderState==0" ghost @click="openOrder">
          取消订单
        </a-button>
        <a-button type="primary" @click="saveEvent">保存备注</a-button>
        <a-button style="margin-left: 10px" @click="backEvent">返回</a-button>
      </div>
      <a-modal title="取消订单" :visible="visible" :width="600" @cancel="visible = false" :footer="null">
        <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="退款金额" prop="refundAmount">
            <a-input v-model="ruleForm.refundAmount" allow-clear :maxLength="20" placeholder="请输入退款金额"
                     style="max-width: 400px;"/>
          </a-form-model-item>
          <a-form-model-item label="确认退款金额" prop="confirmAmount">
            <a-input v-model="ruleForm.confirmAmount" allow-clear :maxLength="20" placeholder="请输入确认退款金额"
                     style="max-width: 400px;"/>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</a-button>
            <a-button style="margin-left: 10px" @click="visible = false">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>

  </div>
</template>

<script>
export default {
  name: 'CouponOrderDetail',
  data() {
    var checkRefundPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) > Number(this.detail.orderPaidFee)) {
          callback(new Error('退款金额不能大于' + this.detail.orderPaidFee))
        } else {
          callback()
        }
      }, 500)
    }
    var checkAdvicePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) != Number(this.ruleForm.refundAmount)) {
          callback(new Error('两次输入金额必须相同'))
        } else {
          callback()
        }
      }, 500)
    }
    return {
      orderNo: '',
      detail: {},
      remark: '',
      touristsDataList: [],
      submitLoading: false,
      attachedSnapshotList: [],
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      visible: false,
      ruleForm: {
        confirmAmount: '',
        refundAmount: ''
      },
      rules: {
        refundAmount: [
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkRefundPrice, trigger: 'blur' }
        ],
        confirmAmount: [
          { required: true, message: '请输入确认退款金额', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkAdvicePrice, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.orderNo = this.getPageParams().orderNo
    this.getOrderDetail()
  },
  methods: {
    openOrder() {
      this.visible = true
      this.ruleForm.refundAmount = this.detail.orderPaidFee
    },
    getOrderDetail() {
      //二级分销商2 运营商1 总后台 0
      const merchantId = this.$store.getters.userInfo.merchantId
      const path = 'order/orderDetails/' + this.orderNo + '/' + merchantId + '/1'
      this.getHttpServices().getOrderService().get(path)
        .then(detail => {
          if (detail.orderPersonnel && detail.orderPersonnel.length > 0) {
            detail.orderPersonnel.forEach((item, index, arr) => {
              item.rowId = index + '1'
            })
          }
          this.detail = detail
          this.attachedSnapshotList = detail.attachedSnapshotList
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getTouristsColumns() {
      return [
        {
          title: '姓名',
          dataIndex: 'ocustomerInfoName'
        },
        {
          title: '证件类型',
          dataIndex: 'ocustomerInfoCardTypeStr'
        },
        {
          title: '证件号',
          dataIndex: 'ocustomerInfoIdCard'
        },
        {
          title: '联系电话',
          dataIndex: 'ocustomerInfoPhone'
        }
      ]
    },
    //保存备注事件
    saveEvent() {
      if (!this.remark || this.remark.trim().length < 1) {
        this.$message.error('请先填写备注信息')
        return
      }
      const params = {
        orderNo: this.orderNo,
        remark: this.remark,
        type: 1
      }
      this.getHttpServices().getOrderService().post('order/updateOrderRemark', params)
        .then(res => {
          this.$message.success('备注信息保存成功')
          this.getOrderDetail()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onClickItem(str) {
      if (str && str.indexOf('yc:') > -1) {
        let arr = str.split(':')
        if (arr && arr.length > 1) {
          this.goYunCangDetail(arr[1])
        } else {
          this.$message.error('关联抢购订单号有误')
        }
      } else {
        this.goOrderDetail(str)
      }
    },
    goYunCangDetail(orderId) {
      const userInfo = this.$store.getters.userInfo
      const platformConfig = this.$store.getters.platformConfig
      const childAccountId = userInfo.account && userInfo.account > 3 ? userInfo.account : 0
      let url = platformConfig.cloudUrl + '/warehouse/center/details?type=200&menustype=0&merchantOppId=' + userInfo.merchantId + '&platformId=' + platformConfig.platformId + '&childAccountId=' + childAccountId + '&orderId=' + orderId
      window.open(url)
    },
    goOrderDetail(orderNo) {
      this.openNewWindowPage('OrderDetails', { orderNo: orderNo })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getPayApiService().post('order/cancelBespeakOrder', {
        orderNo: this.orderNo,
        amount: params.confirmAmount
      }).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.visible = false
        this.ruleForm = {
          confirmAmount: '',
          refundAmount: ''
        }
        this.$message.success('订单取消成功')
        this.getOrderDetail()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style scoped>
.line-a {
  display: block;
}
</style>